<template>
  <FiltersItem>
    <template #title>
      {{ $l('showresult.filter.priceTitle') }}
    </template>
    <template #content>
      <!-- Price range -->
      <FiltersItemPriceRange v-if="resultsQueryStore?.state?.response?.uniquePrices?.length" />

      <!-- Payment method -->
      <FiltersItemPaymentMethod v-if="resultsQueryStore?.state?.response?.uniquePaymentMethods?.length" />
    </template>

    <template #summary>
      <FiltersItemSummary :items="summaryItems" />
    </template>
  </FiltersItem>
</template>

<script setup>
import { lc, lreplace } from '@utils/toolbox';

import { useFiltersStore } from './store/filtersStore';
import { useResultQueryStore } from './store/resultQueryStore';

const filtersStore = useFiltersStore();
const resultsQueryStore = useResultQueryStore();

const summaryItems = computed(() => {
	const summary = [];

	// Price
	if (filtersStore.state.price) {
		const price = lreplace('showresult.filter.summary.totalPrice', { lc: lc(filtersStore.state.price) });
		summary.push(price);
	}

	if (filtersStore.state.paymentMethodIncluded) {
		const cardType = js_params.module.Filters.paymentMethodsAll[filtersStore.state.paymentMethodIncluded];
		summary.push(lreplace('showresult.filter.summary.paymentWith', { card: cardType }));
	}

	return summary;
});

</script>
